import React, { FunctionComponent, useEffect } from 'react';
import { withRouter, match, Switch } from 'react-router-dom';
import { map, addIndex } from 'ramda';
import { compose } from 'recompose';
import withStyles from 'react-jss';
import { Grid } from 'semantic-ui-react';

import { Tabs } from 'components/TabbedMenu/TabbedMenu.helper';
import { ClassProp } from 'helpers/types';
import MerchantVenuesOnboarding from 'scenes/Home/scenes/MerchantVenuesOnboarding';
import Tier3VenueOnboarding from 'scenes/Tier3VenueOnboarding';
import ProtectedRoute from 'components/ProtectedRoute';

import MerchantOverview from '../sections/MerchantOverview';
import MerchantVenues from '../sections/MerchantVenues';
import MerchantLift from '../sections/MerchantLift';

type Params = {
  history: History;
  location: Location;
  match: match;
};

type Styles = ClassProp<typeof styles>;

type Props = {
  classes: Styles;
  match: match;
};

const styles = {
  grid: {
    margin: '1rem 0 0 0 !important',
  },
  container: {
    marginTop: '12rem !important',
    justifyContent: 'center !important',
  },
};

const tabItems: Tabs[] = [
  {
    label: 'Overview',
    path: '/overview',
    key: 'overview',
    component: MerchantOverview,
  },
  {
    label: 'Lift',
    path: '/lift',
    key: 'lift',
    component: MerchantLift,
  },
  {
    label: 'Venues',
    path: '/venues',
    key: 'venues',
    component: MerchantVenues,
    exact: true,
  },
  {
    label: 'Manage Venues',
    path: '/venues/management',
    key: 'manage-venues',
    component: MerchantVenuesOnboarding,
    hideItem: true,
    exact: true,
  },
  {
    label: 'Onboard Venues',
    path: '/venue/onboarding',
    key: 'venue-onboarding',
    component: Tier3VenueOnboarding,
    hideItem: true,
    exact: true,
  },
];

const mapIndexed = addIndex<Tabs>(map);

const renderComponent = (Component: any) => (props: Params) => (
  <Component {...props} />
);

const renderRoutes = (match: match) => (
  { path, key, component, exact }: Tabs,
  idx: number,
) => (
  <ProtectedRoute
    path={`${match.path}${path}`}
    component={renderComponent(component) as FunctionComponent}
    key={`${key}_${idx}`}
    exact={exact}
  />
);

const MerchantLandingPage: FunctionComponent<Props> = ({ classes, match }) => {
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, []);

  return (
    <Grid columns="equal" className={classes.grid}>
      <Grid.Row>
        <Switch>{mapIndexed(renderRoutes(match), tabItems)}</Switch>
      </Grid.Row>
    </Grid>
  );
};

export default compose<Props, any>(
  withStyles(styles),
  withRouter,
)(MerchantLandingPage);
